import React from "react";
import { Task } from "../Task/Task";
import { TaskDetails } from "../../../../services/retail/task/useGetTaskDetails";

interface IFinishedTaskWrapper {
  task: TaskDetails;
  refetchTask: any;
}

export const FinishedTaskWrapper: React.FC<IFinishedTaskWrapper> = ({
  task,
  refetchTask,
}) => {
  return <Task task={task} actionButtons={<></>} />;
};
